function IsNullOrWhitespace(input) {
  return !input || input.trim().length < 1;
}

export { IsNullOrWhitespace };
